import React from 'react';

import { VALUE_FIELDS } from 'store/carInstance/constants';

import { DEFAULT_OUTPUT_DATE_FORMAT } from '../../VehicleInformation.constants';

import { BankSearcher } from '../BankSearcher/BankSearcher';

import { usePurchaseMethodPresenter } from './PurchaseMethod.presenter';
import * as S from './PurchaseMethod.styles';

export const PurchaseMethod = () => {
  const presenter = usePurchaseMethodPresenter();

  return (
    <>
      <S.ButtonsWrapper>
        <S.Button
          active={presenter.isInCredit}
          disabled={presenter.disabled}
          onClick={presenter.onClickCreditButton}
        >
          Кредит
        </S.Button>
        <S.Button
          active={!presenter.isInCredit}
          disabled={presenter.disabled}
          onClick={presenter.onClickCashButton}
        >
          Наличные
        </S.Button>
      </S.ButtonsWrapper>
      <S.FormWrapper>
        {presenter.isInCredit && <BankSearcher />}
        <S.CarIssueDatePicker
          disabled={presenter.disabled}
          error={presenter.errors[VALUE_FIELDS.CAR_ISSUE_DATE]}
          full={!presenter.isInCredit}
          outputFormat={DEFAULT_OUTPUT_DATE_FORMAT}
          value={presenter.carIssueDate}
          onChange={presenter.onChangeInput}
        />
      </S.FormWrapper>
    </>
  );
};
